import { Component, OnDestroy, OnInit, computed, inject, model, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { webDtos } from '@vectronic/openApi-admin';
import { Subscription } from 'rxjs';
import { CameraScheduleService } from '../../../services/camera-schedule.service';
import { CameraCalendarDayViewComponent } from '../camera-calendar-day-view/camera-calendar-day-view.component';
import { CameraCalendarMonthViewComponent } from '../camera-calendar-month-view/camera-calendar-month-view.component';
import { CameraCalendarYearViewComponent } from '../camera-calendar-year-view/camera-calendar-year-view.component';

@Component({
  selector: 'rc-camera-calendar',
  templateUrl: './camera-calendar.component.html',
  styleUrls: ['./camera-calendar.component.scss'],
  imports: [
    MatCard,
    MatCardTitle,
    MatDivider,
    MatCardContent,
    MatButtonModule,
    MatIcon,
    MatTooltip,
    CameraCalendarDayViewComponent,
    CameraCalendarMonthViewComponent,
    CameraCalendarYearViewComponent,
  ],
})
export class CameraCalendarComponent implements OnInit, OnDestroy {
  cameraScheduleService = inject(CameraScheduleService);
  selectedDate = signal<Date | null>(new Date());
  step = signal(0);
  rules = signal<{ [key: number]: webDtos.ScheduleRule }>(undefined);
  subscription: Subscription;
  showPreview = model(false);

  showPreviewLabel = computed(() => (this.showPreview() ? 'Hide preview' : 'Show preview'));

  ngOnInit() {
    this.subscription = this.cameraScheduleService.rules$.subscribe((rules) => {
      this.rules.set(rules);
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onMonthChange(date: Date) {
    this.selectedDate.set(date);
    this.step.set(1);
  }

  onDayChange(date: Date) {
    this.selectedDate.set(date);
    this.step.set(2);
  }

  onDayBackClicked() {
    this.step.set(1);
  }

  onMonthBackClicked() {
    this.step.set(0);
  }

  onYearChange(date: Date) {
    this.selectedDate.set(date);
  }
}
